const extractDomain = url => {
  try {
    const hostname = new URL(url).hostname;
    const parts = hostname.split('.');

    // If there are more than two parts, it's likely to have a subdomain
    if (parts.length > 2) {
      return parts.slice(-2).join('.');
    }

    return hostname;
  } catch {
    return url;
  }
};

const getHost = url => {
  try {
    return new URL(url).host;
  } catch {
    return null;
  }
};

const fixedEncodeURIComponent = str =>
  encodeURIComponent(str).replace(/[!'()*]/g, c => `%${c.charCodeAt(0).toString(16)}`);

export { extractDomain, getHost, fixedEncodeURIComponent };
